// extracted by css-extract-rspack-plugin
export default {"root":"eA_u3"};